import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/authorization/authorization.service';
import { ICCookieService } from '../services/cookie/iccookie.service';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { throwError } from 'rxjs/internal/observable/throwError';

export const JwtInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/api/v1/autenticacion/refrescartoken')) {
    return next(req);
  }

  const authService = inject(AuthService);
  const cookieService = inject(ICCookieService);

  const accessToken = cookieService.getCookie('accessToken');
  const idEmpresa = cookieService.getCookie('IDEMPRESA');
  const idOrganizacion = cookieService.getCookie('IDORGC_SSO');
  const idUsuario = cookieService.getCookie('IDUSUARIO');

  const addHeaders = (request: typeof req, token: string) => {
    return request.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Usuario': idUsuario,
        'X-Empresa': idEmpresa,
        'X-Organizacion': idOrganizacion,
      },
    });
  };

  if (!accessToken) {
    return authService.refreshToken().pipe(
      switchMap(() => {
        const newToken = cookieService.getCookie('accessToken');
        return next(addHeaders(req, newToken));
      })
    );
  }

  const authReq = addHeaders(req, accessToken);

  return next(authReq).pipe(
    catchError((error) => {
      if (error.status !== 401) return throwError(() => error);

      return authService.refreshToken().pipe(
        switchMap(() => {
          const newToken = cookieService.getCookie('accessToken');
          return next(addHeaders(req, newToken));
        }),
        catchError(() => {
          return throwError(() => error);
        })
      );
    })
  );
};
